import React, { Component, PropTypes } from 'react';
import classnames from 'classnames'
import Money from '../Money'
import locale from './locale'
import './ClassBillingMethod.scss';

export function validateClassBillingMethod({feeType, consumption_type, totalPrice, unitPrice}) {
  // mind fucked validation, sometimes feeType is a number, sometimes it's string......kill me now

  // if feetype is "term"
  if (feeType == 0) {
    // and if there's no consumption_type or !totalPrice, it should failed validation
    if (!consumption_type || !totalPrice) {
      return {
        ok: false,
        failed: {
          because: ['required']
        }
      }
      // if consumption_type is not "term/ one fixed rate" and there's no unitPrice, it should also failed
    } else if (consumption_type != 3 && !unitPrice) {
      return {
        ok: false,
        failed: {
          because: ['required']
        }
      }
    }
    // if feeType is not "term"
  } else if (feeType != 0) {
    // and if there is no unitPrice, it should failed
    if(!unitPrice){
      return {
        ok: false,
        failed: {
          because: ['required']
        }
      }
    }
  }
}

class ClassBillingMethod extends Component{
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this)
  }

  onChange(itemName, itemValue) {
    const {
      value,
      onChange,
    } = this.props;

    onChange({
      ...value,
      [itemName]: itemValue,
    }, itemName);
  }

  render(){
    const {value, mode} = this.props;

    return (
      <div className='billing-method-container'>
        <div className='row' style={{marginBottom: '10px'}}>
          <Money
            onChange={(e) => {
              value.feeType == 0 ? this.onChange('totalPrice', e) : this.onChange('unitPrice', e)
            }}
            className='col-xs-8'
            value={value.feeType == 0 ? value.totalPrice : value.unitPrice}
          />
          <div className='col-xs-4'>
            <select
              className='form-control'
              onChange={(e) => {this.onChange('feeType', e.target.value)}}
              value={value.feeType}
              disabled={mode == 'update' ? true : false}
            >
              <option value='1'>{__('By lessons', locale)}</option>
              <option value='2'>{__('By hours', locale)}</option>
              <option value='0'>{__('By terms', locale)}</option>
            </select>
          </div>
        </div>
        {value.feeType == 0 && <div>
          <div className='row'>
            <div className='col-xs-6'>
              <label className='control'>
              <input
                id='none'
                type='radio'
                className="radio"
                value='3'
                onChange={(e)=>{this.onChange('consumption_type', e.target.value)}}
                checked={value.consumption_type == 3 ? 'checked' : ''}
              />
              <span className='radiomark'></span>
              {__('None', locale)}
              </label>
            </div>
          </div>
          <div className='row'>
            <div className='col-xs-4'>
            <label className='control'>
            <input
                id='lessonRate'
                type='radio'
                className="radio"
                value='1'
                onChange={(e)=>{this.onChange('consumption_type', e.target.value)}}
                checked={value.consumption_type == 1 ? 'checked' : ''}
              />
              <span className='radiomark'></span>
              {__('Lesson rate', locale)}
            </label>   
            </div>
            {value.consumption_type == 1 && <Money
              onChange={(e) => {this.onChange('unitPrice', e)}}
              className='col-xs-8'
              value={value.unitPrice}
            />}
          </div>
          <div className='row'>
            <div className='col-xs-4'>
            <label className='control'>
            <input
                id='hourRate'
                type='radio'
                className="radio"
                value='2'
                onChange={(e)=>{this.onChange('consumption_type', e.target.value)}}
                checked={value.consumption_type == 2 ? 'checked' : ''}
              />
              <span className='radiomark'></span>
              {__('Hour rate', locale)}
            </label>
            </div>
            {value.consumption_type == 2 && <Money
              onChange={(e) => {this.onChange('unitPrice', e)}}
              className='col-xs-8'
              value={value.unitPrice}
            />}
          </div>
        </div>}
        {value.feeType == 1 && <p>{__('Classes are charged at the price of each lessons and are calculated for consumption according to lessons used.', locale)}</p>}
        {value.feeType == 2 && <p>{__('Classes are charged at the price of each class hours and are calculated for consumption according to class hours used.', locale)}</p>}
        {(value.feeType == 0 && value.consumption_type == 1) && <p>
          {__('Classes are charged at the price of each term and are calculated for consumption according to lessons used.', locale)}
        </p>}
        {(value.feeType == 0 && value.consumption_type == 2) && <p>
          {__('Classes are charged at the price of each term and are calculated for consumption according to class hours used.', locale)}
        </p>}
        {(value.feeType == 0 && value.consumption_type == 3) && <p>
          {__('Classes are charged at the price of each term and are calculated for consumption after the fee is paid.', locale)}
        </p>}
      </div>
    )
  }
}

export default ClassBillingMethod;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/ClassBillingMethod/index.js